var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206.618,
    height: 291.999,
    viewBox: "0 0 206.618 291.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5498",
    "data-name": "Group 5498",
    transform: "translate(1516.799 11342.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7513",
    "data-name": "Path 7513",
    d: "M206.618,1293.866c0,15.286-46.253,27.678-103.309,27.678S0,1309.153,0,1293.866s46.253-27.678,103.309-27.678,103.309,12.392,103.309,27.678",
    transform: "translate(-1516.799 -12372.545)",
    fill: "#f5f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7514",
    "data-name": "Path 7514",
    d: "M312.088,6.142h80.074a10.69,10.69,0,0,1,6.087,1.87A9.344,9.344,0,0,0,389,0H315.26a9.344,9.344,0,0,0-9.246,8,10.691,10.691,0,0,1,6.074-1.862",
    transform: "translate(-1765.621 -11343.004)",
    fill: "#bdb6b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7515",
    "data-name": "Path 7515",
    d: "M661.937,961.8l6.157,3.637,1.288-2.18-6.157-3.637a7.285,7.285,0,0,1-3.326-8.008l-2.455-.617a9.832,9.832,0,0,0,4.493,10.806",
    transform: "translate(-2051.133 -12116.259)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7516",
    "data-name": "Path 7516",
    d: "M716.667,1019.2l-3.633-2.146a1.487,1.487,0,0,1-.524-2.037l.681-1.152a1.487,1.487,0,0,1,2.037-.524l3.634,2.146a1.487,1.487,0,0,1,.524,2.037l-.681,1.152a1.488,1.488,0,0,1-2.037.524",
    transform: "translate(-2095.977 -12166.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7517",
    "data-name": "Path 7517",
    d: "M368.829,127.353l-.17-3.718-.195-3.716-.391-7.432-.9-14.855-.225-3.714-.252-3.712-.512-7.423-1.024-14.846L364.019,53.1l-.574-7.419-.289-3.709-.318-3.707-1.273-14.828-.695-7.41-.348-3.7-.373-3.7-.013.025A9.345,9.345,0,0,0,350.817,0H277.075a9.346,9.346,0,0,0-9.32,8.659l-.4,3.66-.348,3.7-.695,7.41-1.274,14.828-.318,3.707-.289,3.709-.573,7.419-1.145,14.837-1.024,14.846-.512,7.423-.252,3.712-.225,3.714-.9,14.855-.391,7.432-.195,3.716-.17,3.718.054-.075a13.221,13.221,0,0,0,13.2,13.9h83.276a13.221,13.221,0,0,0,13.2-13.886Z",
    transform: "translate(-1727.436 -11343.003)",
    fill: "#ada8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7518",
    "data-name": "Path 7518",
    d: "M816.774,647.539v-8.386c5.287,0,9.579-3.2,9.77-7.291l.718-15.317c.2-4.193-1.769-8.165-5.533-11.186a22.747,22.747,0,0,0-14.247-4.683H797.415v-8.387h10.068a35.2,35.2,0,0,1,22.048,7.248c5.826,4.674,8.867,10.822,8.563,17.311l-.717,15.317c-.194,4.149-2.429,8.022-6.291,10.9a24,24,0,0,1-14.311,4.469",
    transform: "translate(-2165.182 -11824.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7519",
    "data-name": "Path 7519",
    d: "M816.774,647.539v-8.386c5.287,0,9.579-3.2,9.77-7.291l.718-15.317c.2-4.193-1.769-8.165-5.533-11.186a22.747,22.747,0,0,0-14.247-4.683H797.415v-8.387h10.068a35.2,35.2,0,0,1,22.048,7.248c5.826,4.674,8.867,10.822,8.563,17.311l-.717,15.317c-.194,4.149-2.429,8.022-6.291,10.9a24,24,0,0,1-14.311,4.469",
    transform: "translate(-2165.182 -11824.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7520",
    "data-name": "Path 7520",
    d: "M829.531,599.537a35.2,35.2,0,0,0-22.048-7.248H797.415v0c8.135.072,15.711,2.328,21.371,6.376,5.752,4.114,8.756,9.524,8.456,15.236l-.7,17.958c-.191,4.089-4.483,7.291-9.771,7.291v8.386a24,24,0,0,0,14.311-4.47c3.863-2.882,6.1-6.755,6.291-10.9l.717-15.317c.3-6.489-2.737-12.637-8.563-17.311",
    transform: "translate(-2165.182 -11824.594)",
    fill: "#262424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7521",
    "data-name": "Path 7521",
    d: "M111.693,647.539v-8.386c-5.287,0-9.579-3.2-9.77-7.291l-.717-15.317c-.2-4.193,1.769-8.165,5.533-11.186a22.747,22.747,0,0,1,14.247-4.683h10.068v-8.387H120.985a35.2,35.2,0,0,0-22.048,7.248c-5.826,4.674-8.867,10.822-8.563,17.311l.717,15.317c.195,4.149,2.429,8.022,6.291,10.9a24,24,0,0,0,14.311,4.469",
    transform: "translate(-1590.266 -11824.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7522",
    "data-name": "Path 7522",
    d: "M111.693,647.539v-8.386c-5.287,0-9.579-3.2-9.77-7.291l-.717-15.317c-.2-4.193,1.769-8.165,5.533-11.186a22.747,22.747,0,0,1,14.247-4.683h10.068v-8.387H120.985a35.2,35.2,0,0,0-22.048,7.248c-5.826,4.674-8.867,10.822-8.563,17.311l.717,15.317c.195,4.149,2.429,8.022,6.291,10.9a24,24,0,0,0,14.311,4.469",
    transform: "translate(-1590.266 -11824.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7523",
    "data-name": "Path 7523",
    d: "M109.681,598.668c5.66-4.047,13.236-6.3,21.371-6.376v0H120.985a35.205,35.205,0,0,0-22.048,7.248c-5.826,4.674-8.867,10.822-8.563,17.311l.717,15.317c.195,4.149,2.429,8.022,6.291,10.9a24,24,0,0,0,14.311,4.469v-8.386c-5.287,0-9.579-3.2-9.77-7.291l-.7-17.958c-.3-5.711,2.7-11.122,8.456-15.236",
    transform: "translate(-1590.266 -11824.594)",
    fill: "#262424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7524",
    "data-name": "Path 7524",
    d: "M314.217,776.078a14.145,14.145,0,0,0-3.795-9.789,34.528,34.528,0,0,0-24.889-10.9H200.508a34.528,34.528,0,0,0-24.889,10.9,14.145,14.145,0,0,0-3.795,9.789c0,12.1,8.906,21.916,19.891,21.916h102.61C305.311,797.994,314.217,788.182,314.217,776.078Z",
    transform: "translate(-1656.51 -11957.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7525",
    "data-name": "Path 7525",
    d: "M310.422,765.283a36.251,36.251,0,0,0-24.889-9.895H200.508a36.251,36.251,0,0,0-24.889,9.895,12.211,12.211,0,0,0-3.795,8.884,19.891,19.891,0,0,0,19.891,19.891h102.61a19.891,19.891,0,0,0,19.891-19.891,12.211,12.211,0,0,0-3.795-8.884",
    transform: "translate(-1656.51 -11957.21)",
    fill: "#142736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7526",
    "data-name": "Path 7526",
    d: "M300.472,886.141H190.082a22.129,22.129,0,0,1-15.483-6.168,19.894,19.894,0,0,0,19.373,15.386h102.61a19.894,19.894,0,0,0,19.372-15.386,22.128,22.128,0,0,1-15.482,6.168",
    transform: "translate(-1658.767 -12058.511)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7527",
    "data-name": "Path 7527",
    d: "M314.082,141.182H355.72A13.224,13.224,0,0,0,368.909,127L360.274,8.67A9.346,9.346,0,0,0,350.953,0H277.211A9.346,9.346,0,0,0,267.89,8.67L259.255,127a13.224,13.224,0,0,0,13.189,14.186Z",
    transform: "translate(-1727.572 -11343.004)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7528",
    "data-name": "Path 7528",
    d: "M368.768,161.122l-.195-3.716-.391-7.432-.9-14.855-.225-3.714-.252-3.712-.512-7.423-1.024-14.846-1.145-14.837-.573-7.419-.289-3.709-.318-3.707-1.274-14.828-.695-7.41-.348-3.7-.373-3.7-1.271,2.457-.063.122A37.9,37.9,0,0,0,354.9,68.779l.356,4.859-9.492-.077-11.227-.033-22.454-.062-22.454.063-11.227.033-5.535.045.354-4.827A37.9,37.9,0,0,0,269.2,48.685l-.063-.122-1.271-2.457-.373,3.7-.348,3.7-.695,7.41-1.273,14.828-.318,3.707-.289,3.709L264,90.586l-1.145,14.837-1.024,14.846-.512,7.423-.252,3.712-.225,3.714-.9,14.855-.391,7.432-.195,3.716-.17,3.718,1.731-2.416.079-.11a37.38,37.38,0,0,0,6.763-18.967l.03-.406c7.39,1.037,14.78,1.621,22.171,2.054q12.552.7,25.1.687,12.552.008,25.1-.678c6.729-.394,13.458-.914,20.187-1.791l.01.135a37.38,37.38,0,0,0,6.763,18.967l.078.11,1.731,2.416ZM289.63,76.516q11.227.7,22.454.686,11.227.008,22.454-.678c6.923-.453,13.845-1.074,20.768-2.212l2.457,33.538L350.7,107.8l-12.552-.033-25.1-.062-25.1.063-12.552.033-5.029.036L272.774,74.9c5.619.771,11.238,1.248,16.857,1.617m63.09,65.523-12.552-.033-25.1-.062-25.1.063-12.552.033-9.557.069,2.406-32.832c5.9.691,11.791,1.133,17.687,1.479q12.552.7,25.1.686,12.552.008,25.1-.678c6.567-.384,13.133-.89,19.7-1.729l2.422,33.059Z",
    transform: "translate(-1727.545 -11380.489)",
    fill: "#142736"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    "data-name": "Rectangle 1042",
    width: 7.074,
    height: 8.188,
    transform: "translate(-1363.423 -11103.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7529",
    "data-name": "Path 7529",
    d: "M817.953,1305.139a6.456,6.456,0,1,1-6.456-6.456,6.456,6.456,0,0,1,6.456,6.456",
    transform: "translate(-2171.384 -12398.967)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7530",
    "data-name": "Path 7530",
    d: "M825.62,1313.021a5.263,5.263,0,1,1-5.263-5.263,5.263,5.263,0,0,1,5.263,5.263",
    transform: "translate(-2179.558 -12406.346)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    width: 7.074,
    height: 8.188,
    transform: "translate(-1474.572 -11103.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7531",
    "data-name": "Path 7531",
    d: "M223.236,1305.139a6.456,6.456,0,1,1-6.456-6.456,6.456,6.456,0,0,1,6.456,6.456",
    transform: "translate(-1687.816 -12398.967)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 7.074,
    height: 8.188,
    transform: "translate(-1464.234 -11074.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7532",
    "data-name": "Path 7532",
    d: "M278.548,1462.719a6.456,6.456,0,1,1-6.456-6.456,6.456,6.456,0,0,1,6.456,6.456",
    transform: "translate(-1732.79 -12527.096)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    width: 7.074,
    height: 8.188,
    transform: "translate(-1373.021 -11074.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7533",
    "data-name": "Path 7533",
    d: "M766.6,1462.719a6.456,6.456,0,1,1-6.456-6.456,6.456,6.456,0,0,1,6.456,6.456",
    transform: "translate(-2129.625 -12527.096)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7534",
    "data-name": "Path 7534",
    d: "M264.788,1282.747l58.839-30.948a1.424,1.424,0,0,0,.6-1.923l-3.631-6.9a1.424,1.424,0,0,0-1.923-.6l-54.859,28.854a5.921,5.921,0,0,0-2.484,8l1.538,2.924a1.424,1.424,0,0,0,1.924.6",
    transform: "translate(-1728.731 -12353.049)",
    fill: "#262424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7535",
    "data-name": "Path 7535",
    d: "M595.67,1237.7H542.224v10.649h59.965a2.065,2.065,0,0,0,2.065-2.065,8.584,8.584,0,0,0-8.584-8.584",
    transform: "translate(-1957.685 -12349.379)",
    fill: "#262424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7536",
    "data-name": "Path 7536",
    d: "M546.292,1282.747,487.453,1251.8a1.424,1.424,0,0,1-.6-1.923l3.631-6.9a1.424,1.424,0,0,1,1.924-.6l54.859,28.854a5.921,5.921,0,0,1,2.484,8l-1.538,2.924a1.424,1.424,0,0,1-1.923.6",
    transform: "translate(-1912.531 -12353.049)",
    fill: "#262424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7537",
    "data-name": "Path 7537",
    d: "M556.909,1270.965l-51.935-27.316a2.065,2.065,0,0,0-2.789.866l-.739,1.406a2.065,2.065,0,0,1,2.12-.119l51.935,27.316a8.585,8.585,0,0,1,4.15,10.3,2.052,2.052,0,0,0,.859-.862,8.584,8.584,0,0,0-3.6-11.593",
    transform: "translate(-1924.528 -12354.024)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7538",
    "data-name": "Path 7538",
    d: "M218.909,1237.7a8.584,8.584,0,0,0-8.584,8.584,2.065,2.065,0,0,0,2.065,2.065h59.965V1237.7Z",
    transform: "translate(-1687.816 -12349.379)",
    fill: "#262424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7539",
    "data-name": "Path 7539",
    d: "M595.67,1237.7H542.224v2.813H595.67a8.586,8.586,0,0,1,8.37,6.683,2.053,2.053,0,0,0,.214-.911,8.584,8.584,0,0,0-8.584-8.584",
    transform: "translate(-1957.685 -12349.379)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7540",
    "data-name": "Path 7540",
    d: "M495.265,1007.344H473.52a2.42,2.42,0,0,0-2.42,2.42v1.1a3.5,3.5,0,0,0,3.5,3.5h19.588a3.5,3.5,0,0,0,3.5-3.5v-1.1a2.42,2.42,0,0,0-2.42-2.42",
    transform: "translate(-1899.854 -12162.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7541",
    "data-name": "Path 7541",
    d: "M482.386,990.374H454.144a2.879,2.879,0,0,1-2.879-2.879v-4.14h34v4.14a2.879,2.879,0,0,1-2.879,2.879",
    transform: "translate(-1883.725 -12142.571)",
    fill: "#262424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7542",
    "data-name": "Path 7542",
    d: "M497.219,1026H471.567a4.248,4.248,0,0,1-.465-.027c0,.009,0,.018,0,.027a3.509,3.509,0,0,0,3.509,3.509h19.567a3.509,3.509,0,0,0,3.509-3.509c0-.009,0-.018,0-.027a4.247,4.247,0,0,1-.466.027",
    transform: "translate(-1899.854 -12177.226)",
    fill: "#262424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7543",
    "data-name": "Path 7543",
    d: "M322.856,1243.517a2.06,2.06,0,0,0-.694.218l-51.935,27.316a8.584,8.584,0,0,0-3.6,11.593,2.055,2.055,0,0,0,.86.862,8.585,8.585,0,0,1,4.144-10.323l51.227-26.943Z",
    transform: "translate(-1732.791 -12354.11)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7544",
    "data-name": "Path 7544",
    d: "M218.909,1237.7a8.584,8.584,0,0,0-8.584,8.584,2.052,2.052,0,0,0,.214.911,8.585,8.585,0,0,1,8.37-6.682h53.446V1237.7Z",
    transform: "translate(-1687.816 -12349.379)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7545",
    "data-name": "Path 7545",
    d: "M508.278,1129.294v26.189c0,1.219,2.841,2.208,6.345,2.208s6.344-.988,6.344-2.208v-26.189Z",
    transform: "translate(-1930.083 -12261.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7546",
    "data-name": "Path 7546",
    d: "M520.966,1119.69c0,1.219-2.84,2.208-6.344,2.208s-6.344-.988-6.344-2.208,2.841-2.207,6.344-2.207,6.344.988,6.344,2.207",
    transform: "translate(-1930.082 -12251.632)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7547",
    "data-name": "Path 7547",
    d: "M523.786,1095.439v5.728c0,.662,1.543,1.2,3.446,1.2s3.446-.537,3.446-1.2v-5.728Z",
    transform: "translate(-1942.693 -12233.708)",
    fill: "#262424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7548",
    "data-name": "Path 7548",
    d: "M519.671,1054.944h-10.1a1.3,1.3,0,0,1-1.3-1.295v-8.75h12.689v8.75a1.3,1.3,0,0,1-1.295,1.295",
    transform: "translate(-1930.082 -12192.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7549",
    "data-name": "Path 7549",
    d: "M773.389,1471.327a5.263,5.263,0,1,1-5.263-5.263,5.262,5.262,0,0,1,5.263,5.263",
    transform: "translate(-2137.088 -12535.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7550",
    "data-name": "Path 7550",
    d: "M285.3,1471.153a5.263,5.263,0,1,1-5.263-5.263,5.263,5.263,0,0,1,5.263,5.263",
    transform: "translate(-1740.216 -12534.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7551",
    "data-name": "Path 7551",
    d: "M229.144,1313.726a5.263,5.263,0,1,1-5.263-5.262,5.262,5.262,0,0,1,5.263,5.262",
    transform: "translate(-1694.56 -12406.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7552",
    "data-name": "Path 7552",
    d: "M547.266,27.946a2.5,2.5,0,1,1-2.833-2.108,2.5,2.5,0,0,1,2.833,2.108",
    transform: "translate(-1957.745 -11363.987)",
    fill: "#212226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7553",
    "data-name": "Path 7553",
    d: "M547.024,27.909a2.871,2.871,0,1,1-3.257-2.424,2.871,2.871,0,0,1,3.257,2.424",
    transform: "translate(-1956.944 -11363.696)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    width: 5.742,
    height: 5.743,
    transform: "translate(-1415.631 -11338.243)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7554",
    "data-name": "Path 7554",
    d: "M423.686,69.919l-8.115-.027-28.65-30a4.13,4.13,0,0,0-2.994-1.3,4.074,4.074,0,0,0-2.985,1.278L352.5,69.681l-8.115-.027a2.558,2.558,0,0,0-2.541,2.6l.153,44.425a2.6,2.6,0,0,0,2.559,2.617l79.3.265a2.558,2.558,0,0,0,2.541-2.6l-.153-44.425a2.6,2.6,0,0,0-2.559-2.617M381.817,40.751a2.885,2.885,0,0,1,2.115-.905,2.926,2.926,0,0,1,2.121.92l27.816,29.122-59.668-.2Z",
    transform: "translate(-1794.753 -11374.385)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 84.555,
    height: 80.961,
    transform: "translate(-1452.911 -11335.786)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7555",
    "data-name": "Path 7555",
    d: "M429.3,69.684a.606.606,0,0,1-.436-.183L395.36,35.2a2.959,2.959,0,0,0-4.234,0l-33.5,34.309a.609.609,0,1,1-.871-.851l33.5-34.309a4.177,4.177,0,0,1,5.976,0l33.508,34.3a.609.609,0,0,1-.435,1.034",
    transform: "translate(-1806.736 -11369.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7556",
    "data-name": "Path 7556",
    d: "M408.884,244.628l-79.264.007a2.548,2.548,0,0,1-2.548-2.548l0-43.408a2.548,2.548,0,0,1,2.548-2.549l79.264-.007a2.548,2.548,0,0,1,2.548,2.548l0,43.408a2.548,2.548,0,0,1-2.548,2.548",
    transform: "translate(-1782.74 -11502.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7557",
    "data-name": "Path 7557",
    d: "M543.706,26.957a2.7,2.7,0,1,1-3.058-2.276,2.7,2.7,0,0,1,3.058,2.276",
    transform: "translate(-1954.529 -11363.045)",
    fill: "#212226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8220",
    "data-name": "Path 8220",
    d: "M15.751,14.218c-3.865.356-6.286,3.628-5.886,7.957.387,4.192,3.278,6.879,7.031,6.532,3.268-.3,6.355-2.885,5.885-7.976-.386-4.181-3.277-6.86-7.03-6.513M16.761,26.2c-2.442.225-3.777-2.09-3.985-4.338-.221-2.4.66-4.921,3.129-5.149,2.441-.225,3.778,2.1,3.986,4.357.221,2.39-.661,4.9-3.13,5.13",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8221",
    "data-name": "Path 8221",
    d: "M31.755,21.237c.218,2.359-.539,3.634-2.25,3.792-2.018.186-2.62-1.707-2.77-3.329l-.757-8.213-2.82.26.755,8.175c.488,5.3,3.822,5.785,5.766,5.606,3.465-.32,5.246-2.75,4.884-6.666l-.747-8.1L31,13.024Z",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8222",
    "data-name": "Path 8222",
    d: "M34.336,15.287l3.929-.363,1.062,11.5,2.819-.26-1.061-11.5,3.947-.364L44.8,11.749l-10.7.987Z",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8223",
    "data-name": "Path 8223",
    d: "M54.944,10.6c-3.865.356-6.286,3.628-5.886,7.957.387,4.192,3.278,6.879,7.031,6.532,3.268-.3,6.355-2.885,5.885-7.976-.386-4.181-3.277-6.86-7.03-6.513m1.01,11.987c-2.442.225-3.777-2.09-3.985-4.338-.221-2.4.66-4.921,3.129-5.149,2.442-.225,3.778,2.1,3.986,4.357.221,2.39-.661,4.9-3.13,5.13",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8224",
    "data-name": "Path 8224",
    d: "M70.7,11.913l-.234-2.532-8.09.747,1.3,14.05,2.8-.258-.539-5.846,4.887-.451-.232-2.512-4.887.451L65.405,12.4Z",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8225",
    "data-name": "Path 8225",
    d: "M18.023,33.124c-4.173.385-6.787,3.918-6.355,8.591.417,4.527,3.539,7.428,7.591,7.054,3.529-.326,6.862-3.115,6.355-8.612-.417-4.515-3.538-7.407-7.591-7.033m1.091,12.943c-2.637.243-4.079-2.257-4.3-4.684-.239-2.59.713-5.313,3.378-5.559,2.637-.244,4.08,2.268,4.305,4.7.238,2.58-.715,5.293-3.38,5.539",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8226",
    "data-name": "Path 8226",
    d: "M27.442,47.784l3.024-.279-.583-6.312,5.277-.487-.251-2.713-5.276.487-.315-3.412,5.712-.527-.253-2.734-8.735.806Z",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8227",
    "data-name": "Path 8227",
    d: "M37.52,46.854l3.024-.279-.583-6.312,5.278-.487-.251-2.713-5.277.487L39.4,34.138l5.711-.527-.252-2.734-8.735.806Z",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2020",
    "data-name": "Rectangle 2020",
    width: 3.036,
    height: 15.235,
    transform: "translate(-1409.008 -11280.247) rotate(-5.273)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8228",
    "data-name": "Path 8228",
    d: "M58.505,32.145a5.9,5.9,0,0,1,2.6.283l.678.253.537-2.714-.468-.191a7.894,7.894,0,0,0-3.658-.359,7.607,7.607,0,0,0-7.163,8.666c.43,4.658,3.653,7.4,8.21,6.976a9.565,9.565,0,0,0,3.89-1.092l.423-.263-.928-2.565-.64.387a6.621,6.621,0,0,1-2.624.765c-2.974.274-4.921-1.43-5.21-4.558-.3-3.22,1.331-5.309,4.356-5.588",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8229",
    "data-name": "Path 8229",
    d: "M67.318,41.347l-.351-3.806,5.421-.5-.25-2.713-5.421.5-.294-3.184,5.732-.529L71.9,28.381l-8.756.808,1.4,15.171,9.065-.836-.252-2.735Z",
    transform: "translate(-1455.207 -11311)",
    fill: "#1d3943"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestChair);
export default __webpack_public_path__ + "static/media/request_chair.59329d88da0348be0e4b4acd5c23e244.svg";
export { ForwardRef as ReactComponent };